export const SECTIONS = {
  ENTERPRISE: 'Enterprise',
  LISTING: 'Listing',
  SPONSORED: 'Sponsored'
};
export const ANALYTICS_SUBJECT_ID_COLLECTION_VIEW_MORE_LINK = 'collectionViewMoreLink';
export const ANALYTICS_SUBJECT_ID_HOME_PAGE_TILES = 'homePageTiles';
export const ANALYTICS_SUBJECT_ID_HIT = 'hit';
export const LARGE = 'large';
export const SMALL = 'small';